import dayjs from "dayjs";
import { maxDays } from "../../../utils/utils";
import { MuiDatePicker } from "../../atoms/datePicker";
import { MuiStack } from "../../atoms/stackComponent";
var DateFilters = function (props) {
    var handleDateChange = props.handleDateChange, StartDocDate = props.StartDocDate, EndDocDate = props.EndDocDate;
    // const lgMode = useMediaQuery('(min-width:600px)');
    return /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        alignItems: "flex-start"
    }, /*#__PURE__*/ React.createElement(MuiDatePicker, {
        label: "From date",
        onChange: handleDateChange,
        value: StartDocDate,
        name: "startDate",
        placeholder: "From date"
    }), /*#__PURE__*/ React.createElement(MuiDatePicker, {
        label: "To date",
        name: "endDate",
        onChange: handleDateChange,
        value: EndDocDate
        // value={endDate || (EndDocDate && convertDate(EndDocDate))}
        ,
        placeholder: "To date",
        disabled: !StartDocDate,
        maxDate: dayjs(StartDocDate).add(maxDays, 'day'),
        minDate: StartDocDate
    }));
};
export default DateFilters;
